module.exports = __webpack_public_path__ + "img/gs4.874f1092.svg";